export default "__VITE_ASSET__CwY2kAO8__"